import { CommonModule } from "@angular/common"
import { Component, OnDestroy, OnInit, inject } from "@angular/core"
import { NavigationEnd, Router, RouterOutlet } from "@angular/router"
import { ConfirmDialog } from "primeng/confirmdialog"
import { ToastModule } from "primeng/toast"
import { LayoutSidebarNavbar } from "../navbar/navbar"
import { LayoutSidebarHeader } from "../header/header"
import { Subject } from "rxjs"
import { filter, takeUntil } from "rxjs/operators"

@Component({
	selector: "app-layout-sidebar",
	imports: [CommonModule, RouterOutlet, LayoutSidebarNavbar, ConfirmDialog, ToastModule, LayoutSidebarHeader],
	// PrimeNG services are provided at application level in appConfig
	standalone: true,
	templateUrl: "./main.html"
})
export class LayoutSidebar implements OnInit, OnDestroy {
	private readonly router = inject(Router)
	private readonly destroy$ = new Subject<void>()
	public isNavbarOpen = false

	public ngOnInit(): void {
		this.router.events
			.pipe(
				filter(event => event instanceof NavigationEnd),
				takeUntil(this.destroy$)
			)
			.subscribe(() => {
				this.closeNavbar()
			})
	}

	public openNavbar() {
		this.isNavbarOpen = true
	}

	public closeNavbar() {
		this.isNavbarOpen = false
	}

	public ngOnDestroy(): void {
		this.destroy$.next()
		this.destroy$.complete()
	}
}
